import { usePublicLanguage } from "../../context/PublicLanguage";
import React from "react";
import { Link } from "react-router-dom";
import Logo from "@/components/Logo";

const COLS = [
  {
    title: "Sections",
    links: [
      ["AI", "/ai"],
      ["Robotics", "/robotics"],
      ["Cybersecurity", "/cybersecurity"],
      ["Future Tech", "/future-tech"],
      ["Business", "/business"],
      ["Guides", "/guides"],
    ],
  },
  {
    title: "TechDishes",
    links: [
      ["Daily Dish", "/daily-dish"],
      ["Search", "/search"],
      ["Newsroom", "/admin"],
    ],
  },
];

export default function Footer() {
  const { t } = usePublicLanguage();
  return (
    <footer className="border-t mt-24" style={{ borderColor: "rgba(255,255,255,0.08)", background: "#08090A" }}>
      <div className="mx-auto max-w-[1320px] px-5 md:px-8 py-14">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <Logo iconSize={40} showTagline />
            <p className="mt-5 text-[#A7ABB0] max-w-sm leading-relaxed" style={{ fontSize: "0.98rem" }}>{t('TechDishes delivers the most important AI and technology stories, insights and guides — carefully researched, clearly explained, and served daily.')}</p>
          </div>
          {COLS.map((col) => (
            <div key={t(col.title)}>
              <div className="td-eyebrow mb-4" style={{ color: "#FF8A1F" }}>
                {t(col.title)}
              </div>
              <ul className="space-y-2.5">
                {col.links.map(([label, to]) => (
                  <li key={to}>
                    <Link to={to} className="text-[#A7ABB0] hover:text-white transition-colors" style={{ fontSize: "0.95rem" }}>
                      {t(label)}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="mt-12 pt-6 border-t flex flex-col md:flex-row items-center justify-between gap-3" style={{ borderColor: "rgba(255,255,255,0.08)" }}>
          <p className="td-eyebrow" style={{ color: "#71767c", fontSize: "0.62rem" }}>
            © {new Date().getFullYear()} TechDishes — {t("A brighter tomorrow, one story at a time.")}
          </p>
        </div>
      </div>
    </footer>
  );
}
